module.exports = __webpack_public_path__ + "static/media/step_1.b9148186.png";